// extracted by mini-css-extract-plugin
export default {"root":"Renewals_root__6baL0"};